import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import MapGetPoint from '@/components/Map/MapGetPoint';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import pick from 'lodash.pick';
import { getAction, httpAction } from '@/api/manage';
import moment from 'moment';
import { queryAreaTreeList, duplicateCheck } from '@/api/api';
export default {
  name: 'TenantModal',
  mixins: [ModalFormMixin],
  components: {
    MapGetPoint: MapGetPoint
  },
  data: function data() {
    return {
      title: '租户表表单',
      tableName: 'sys_tenant',
      form_fields: ['code', 'name', 'phone', 'addr', 'st', 'modelKey', 'appConfig', 'projectName', 'copyright', 'topLogo', 'homeLogo', 'zoomLevel', 'mapCenter', 'homeUrl', 'longitude', 'areaRoot', 'status', 'sort', 'remark', 'maxSite', 'maxUser'],
      form_fields_time: ['startTime', 'endTime'],
      validatorRules: {
        code: {
          rules: [{
            required: true,
            message: '请输入租户编号!'
          }, {
            validator: this.validateCode
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入企业名称!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        },
        projectName: {
          rules: [{
            required: true,
            message: '请输入系统名称!'
          }]
        },
        copyright: {
          rules: [{
            required: true,
            message: '请输入技术支持!'
          }]
        },
        mapCenter: {
          rules: [{
            required: true,
            message: '请选择中心坐标!'
          }]
        }
      },
      headers: {},
      areaTree: [],
      stList: [],
      mapCenter: '',
      topUploadLoading: false,
      uploadLoadingOne: false,
      uploadLoadingTwo: false,
      picUrl: '',
      picUrlOne: '',
      picUrlTwo: '',
      uploadFile: {},
      url: {
        fileUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    var token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      'X-Access-Token': token
    };
  },
  computed: {
    uploadAction: function uploadAction() {
      return this.url.fileUpload;
    }
  },
  methods: {
    validateCode: function validateCode(rule, value, callback) {
      // 重复校验
      var params = {
        tableName: 'sys_tenant',
        fieldName: 'code',
        fieldVal: value,
        dataId: this.model.id
      };
      duplicateCheck(params).then(function (res) {
        if (res.success) {
          callback();
        } else {
          callback(res.message);
        }
      });
    },
    edit: function edit(record) {
      var _this = this;

      this.picUrl = '';
      this.picUrlOne = '';
      this.picUrlTwo = '';
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (typeof this.model.areaRoot != 'undefined' && this.model.areaRoot != null && this.model.areaRoot != '') {
        this.model.areaRoot = this.model.areaRoot.split(',');
      }

      if (typeof this.model.st != 'undefined' && this.model.st != null && this.model.st != '') {
        this.model.st = this.model.st.split(',');
      } else {
        this.model.st = [];
      } // debugger


      this.loadAreas();
      this.loadStList();
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });

      if (this.model.topLogo) {
        this.picUrl = 'Has no pic url yet';
      }

      if (this.model.homeLogo) {
        this.picUrlOne = 'Has no pic url yet';
      }

      if (this.model.appQr) {
        this.picUrlTwo = 'Has no pic url yet';
      }

      if (typeof this.model.mapCenter != 'undefined') {
        this.mapCenter = this.model.mapCenter.split(',');
      }
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          });
          formData.areaRoot = formData.areaRoot != null ? formData.areaRoot.toString() : null;
          formData.st = formData.st != null ? formData.st.toString() : null; //debugger
          //console.log(formData)

          var httpurl = '',
              method = '';

          if (_this2.model.id >= 0) {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          } else {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    //加载区域信息
    loadAreas: function loadAreas() {
      var _this3 = this;

      var that = this;
      that.areaTree = [];
      queryAreaTreeList({
        status: '1',
        tenantId: 0
      }).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            temp.key = temp.key;
            that.areaTree.push(temp);
          }

          _this3.loading = false;
        }
      });
    },
    loadStList: function loadStList() {
      var that = this;
      that.stList = [];
      var params = {
        pageNo: 1,
        pageSize: 10000,
        status: '1'
      };
      getAction('/site/sys/type', params).then(function (res) {
        if (res.success) {
          that.stList = res.result.records;
        }
      });
    },
    stChange: function stChange(code) {
      this.model.st = code.toString();
    },
    longitudeChange: function longitudeChange() {
      this.$refs.mapForm.show(this.mapCenter);
    },
    coordinateOk: function coordinateOk(value) {
      if (value != null) {
        this.mapCenter = value;
        this.form.setFieldsValue({
          mapCenter: value.toString()
        });
      }
    },
    beforeUpload: function beforeUpload(file) {
      var fileType = file.type;

      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      } //TODO 验证文件大小

    },
    handleChange: function handleChange(info) {
      this.picUrl = '';

      if (info.file.status === 'uploading') {
        this.topUploadLoading = true;
        return;
      }

      if (info.file.status === 'done') {
        var response = info.file.response;
        this.topUploadLoading = false;

        if (response.success) {
          this.model.topLogo = response.result.id;
          this.picUrl = 'Has no pic url yet';
        } else {
          this.$notification.warning({
            message: response.message
          });
        }
      }
    },
    handleChangeOne: function handleChangeOne(info) {
      this.picUrlOne = '';

      if (info.file.status === 'uploading') {
        this.uploadLoadingOne = true;
        return;
      }

      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoadingOne = false;

        if (response.success) {
          this.model.homeLogo = response.result.id;
          this.picUrlOne = 'Has no pic url yet';
        } else {
          this.$notification.warning({
            message: response.message
          });
        }
      }
    },
    handleChangeTwo: function handleChangeTwo(info) {
      this.picUrlTwo = '';

      if (info.file.status === 'uploading') {
        this.uploadLoadingTwo = true;
        return;
      }

      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoadingTwo = false;

        if (response.success) {
          this.model.appQr = response.result.id;
          this.picUrlTwo = 'Has no pic url yet';
        } else {
          this.$notification.warning({
            message: response.message
          });
        }
      }
    },
    getAvatarView: function getAvatarView() {
      return this.url.imgerver + '/' + this.model.topLogo;
    },
    getAvatarViewOne: function getAvatarViewOne() {
      return this.url.imgerver + '/' + this.model.homeLogo;
    },
    getAvatarViewTwo: function getAvatarViewTwo() {
      return this.url.imgerver + '/' + this.model.appQr;
    }
  }
};